import React from 'react';
import { BrowserRouter, Route, Switch, HashRouter } from 'react-router-dom';

import { Provider } from 'react-redux';

import 'normalize.css';
import './App.scss';
import './Vendor/styles/bootstrap-utilities.min.css';
import store from './Redux/Store/store';
import AtlasPacker from './Views/AtlasPacker/AtlasPacker';
import AnimationTool from './Views/AnimationTool/AnimationTool';
// import HomePage from './Views/HomePage';
import isElectron from 'is-electron';
import HomePage from './Views/HomePage';

const App: React.FC = () => {
    return (
        <Provider store={store}>
            {isElectron() ? (
                // Rutas electron
                <HashRouter>
                    <Route exact path="/atlas-packer" component={AtlasPacker} />
                    <Route exact path="/animation-tool" component={AnimationTool} />
                    <Route exact path="/" component={HomePage} />
                </HashRouter>
            ) : (
                // Rutas del navegador
                <BrowserRouter>
                    <Switch>
                        {/* Rutas test */}
                        {/* <Route exact path="/animator" component={AnimationTool} /> */}
                        {/* <Route exact path="/" component={AtlasPacker} /> */}
                        {/* Rutas producción web */}
                        <Route exact path="/tool/animator" component={AnimationTool} />
                        <Route exact path="/tool/atlas-packer" component={AtlasPacker} />
                    </Switch>
                </BrowserRouter>
            )}
        </Provider>
    );
};

export default App;
